/**
 * Interface strings of the operator console shell: the grouped section list,
 * the detail header and the new section titles. Keys that also exist in
 * messages.ts (the three relabelled sections) win when this object is spread
 * after the base entries.
 */
export const adminShellMessages = {
  "admin.shell.back": { ru: "Консоль", en: "Console" },
  "admin.shell.title": { ru: "Консоль", en: "Console" },
  "admin.groups.monitoring": { ru: "МОНИТОРИНГ", en: "MONITORING" },
  "admin.groups.people": { ru: "ПОЛЬЗОВАТЕЛИ И ДЕНЬГИ", en: "USERS AND MONEY" },
  "admin.groups.assistant": { ru: "АССИСТЕНТ", en: "ASSISTANT" },
  "admin.groups.access": { ru: "ДОСТУП", en: "ACCESS" },
  "admin.tabs.payments": { ru: "Платежи", en: "Payments" },
  "admin.tabs.access": { ru: "Операторы и роли", en: "Operators and roles" },
  "admin.tabs.audit": { ru: "Журнал аудита", en: "Audit log" },
  // Standalone browser admin (outside Telegram).
  "admin.standalone.prompt": {
    ru: "Войдите через корпоративную учётную запись, чтобы открыть консоль.",
    en: "Sign in with your corporate account to open the console.",
  },
  "admin.standalone.hint": {
    ru: "Если после входа вы снова видите этот экран, операторский доступ для вашей учётной записи не назначен.",
    en: "If you land here again after signing in, operator access is not assigned to your account.",
  },
  "admin.standalone.signOut": { ru: "Выйти", en: "Sign out" },
  "admin.standalone.signOutAria": {
    ru: "Выйти из консоли",
    en: "Sign out of the console",
  },
  // Relabelled existing sections.
  "admin.tabs.load": { ru: "Нагрузка", en: "Load & queues" },
  "admin.tabs.inspector": { ru: "Инспектор", en: "Job inspector" },
  "admin.tabs.feedback": { ru: "Фидбэк", en: "Feedback" },
} as const;

export type AdminShellMessageKey = keyof typeof adminShellMessages;
